import { Actor, CollisionType, vec, Vector } from 'excalibur';
import { hitEffectAnimation } from './animations';

export class HitEffect extends Actor {
  constructor(position: Vector, isCriticalHit: boolean) {
    super({
      pos: position,
      width: 48 * 2,
      height: 48 * 2,
      z: 1000,
      opacity: 0.8,
      collisionType: CollisionType.PreventCollision,
    });

    if (isCriticalHit) {
      this.graphics.use(hitEffectAnimation.critical.clone());
      this.scale = vec(2, 2);
    } else {
      this.graphics.use(hitEffectAnimation.normal().clone());
    }

    this.pos = this.pos.add(vec(Math.random() * 64 - 32, Math.random() * 64 - 32));

    setTimeout(() => {
      this.kill();
    }, 300);
  }
}
